import { styled } from "styled-components";
import HelpCenterHeader from "../components/HelpCenterHeader";
import SearchInput from "../components/SearchInput";
import { ChangeEvent, useState } from "react";
import HelpCenterCard from "../components/HelpCenterCard";
import { HelpCardContent, IHelpCard } from "../components/HelpCenter.config";
import { scrollBarStyles, useDebounce, useDocumentTitle, useMountedEffect } from "@dataone/lib";
import { OneGateLogo_3Icon } from "@dataone/icons";

interface HelpCenterPageProps {
  children?: React.ReactNode;
}

const HelpCenterPage = (props: HelpCenterPageProps) => {
  const [searchContent, setSearchContent] = useState("");
  const [isSearchLoading, setSearchLoading] = useState(false);
  const [filteredArticles, setFilteredArticles] =
    useState<IHelpCard[]>(HelpCardContent);
  const debouncedSearch = useDebounce(searchContent);
  useDocumentTitle("OneGate | Help Center");
  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchLoading(true);
    setSearchContent(value);
    if (value === debouncedSearch) setSearchLoading(false);
  };

  useMountedEffect(() => {
    setFilteredArticles(
      HelpCardContent.filter(
        (card) =>
          card.Title.toLowerCase().includes(
            debouncedSearch?.trim().toLowerCase() ?? ""
          ) ||
          card.subtitles.some((subtitle) =>
            subtitle.title
              .toLowerCase()
              .includes(debouncedSearch?.trim().toLowerCase() ?? "")
          )
      )
    );
    setSearchLoading(false);
  }, [debouncedSearch]);

  return (
    <StyledHelpCenterPage>
      <HelpCenterHeader />
      <StyledTitle>
        <span>
          <OneGateLogo_3Icon />
        </span>
        <h1>How can we help you ? </h1>
        <SearchInput
          handleSearchChange={handleSearchChange}
          placeholder="Search..."
          isSearchLoading={isSearchLoading}
        />
      </StyledTitle>
      <StyledCardsList>
        {filteredArticles.map((content, index) => {
          const isLastCard = content.Title === "Contact OneGate Support";
          return (
            <HelpCenterCard
              key={index}
              title={content.Title}
              content={content.subtitles}
              icon={content.icon}
              path={content.path}
              iContactCard={isLastCard ? true : false}
            />
          );
        })}
      </StyledCardsList>
    </StyledHelpCenterPage>
  );
};

export default HelpCenterPage;

const StyledHelpCenterPage = styled.div`
  padding: 5px 10px;
`;
const StyledTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  h1 {
    color: #4974f6;
    font-size: 24px;
  }
  img {
    height: 60px;
  }
  margin-bottom: 25px;
  margin-top: 10px;
  span {
    font-size: 60px;
    color: #4974f6;
    display: flex;
  }
`;
const StyledCardsList = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  overflow: auto;
  height: calc(100vh - 377px);
  padding-top: 30px;
  ${scrollBarStyles}
`;
